import { BaseService } from 'hungry-core2'

import actions from '@actions'

export default class EditVendorPricingAgreement extends BaseService {
  close = () => {
    this.dispatch(actions.toggleEditVendorPricingAgreementModal(false))
  }

  show = () => {
    this.dispatch(actions.toggleEditVendorPricingAgreementModal(true))
  }
}
